var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10134",
    "data-name": "Group 10134",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.567,
    height: 24,
    viewBox: "0 0 22.567 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4853",
    "data-name": "Rectangle 4853",
    width: 22.567,
    height: 24,
    fill: "#d13c3c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10133",
    "data-name": "Group 10133",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5697",
    "data-name": "Path 5697",
    d: "M14.529,17.907l-3.245,0a.3.3,0,0,0-.325.276.3.3,0,0,0,.326.318l.334.008V22l-1.328,0V16.378H8.574a.362.362,0,0,1-.361-.246.345.345,0,0,1,.147-.415l6.509-3.568a.937.937,0,0,1,.948-.043l6.538,3.582a.36.36,0,0,1-.142.688l-1.739,0V22.01H14.159V18.5l.372-.008a.295.295,0,0,0,0-.589m.739-4.358a.917.917,0,0,0-.8,1.075.923.923,0,1,0,.8-1.075M17.253,17.8l0-1.425h-1.3l0,1.429Zm1.894-.007,0-1.42-1.3,0v1.427Z",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5698",
    "data-name": "Path 5698",
    d: "M9.052,13.2,8,13.361l-.007,1.893a.946.946,0,0,0-.343,1.038.909.909,0,0,0,.838.667l1.213.012v5.038l-2.553,0V2.148L12.171,0l0,12.937-.837.481-.01-.573-1.19.185,0,1.035-1.071.595Zm2.283-8.748-.018-2.09-1.187.509.007,2.035ZM8,5.7l1.061-.4,0-1.967-1.066.451ZM11.334,8l-.016-2.235-1.187.4,0,2.169ZM9.061,8.64l0-2.106-1.064.357,0,2.051Zm2.273,2.906-.015-2.238-1.19.3.005,2.163Zm-2.274.429L9.051,9.867l-1.058.262L8,12.176Z",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5699",
    "data-name": "Path 5699",
    d: "M1.611,22.011l0-13.841L6.557,6.058V22.009Zm4-12.218L5.6,8.088l-.984.417v1.66Zm-1.883.675L3.72,8.877l-.859.364v1.546Zm1.876,2.261L5.6,10.889l-.989.309,0,1.773Zm-1.877.45-.007-1.7-.861.268,0,1.658Zm1.877,2.459L5.6,13.805l-.989.2.006,1.775Zm-1.878.251-.005-1.7-.861.175v1.66Zm1.879,2.724-.005-1.9-.989.1,0,1.823Zm-1.882.022,0-1.73-.861.075v1.66Z",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5700",
    "data-name": "Path 5700",
    d: "M16.133,11.609a1.5,1.5,0,0,0-1.439-.035l-1.93,1.058V0l5.32,2.271v10.4Z",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5701",
    "data-name": "Path 5701",
    d: "M21.754,24H.369A.36.36,0,0,1,0,23.624v-.649A.356.356,0,0,1,.369,22.6H21.754a.356.356,0,0,1,.368.373v.649a.36.36,0,0,1-.369.376",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.797f1541ed7d40d8259598c675adbfbc.svg";
export { ForwardRef as ReactComponent };